export default "/images/88cc3b30a6978f862034fba8f2ff40cb.avif";